export default __webpack_public_path__ + "static/media/s4.ae1ff16a.svg";